module.exports = __webpack_public_path__ + "media/ambience-rehearsal-stage.623f6e50.mp3";